import { Component, Injector, ContentChildren, QueryList, AfterContentInit } from '@angular/core';
import { BaseControlValueAccessor } from '../../../core/base-control-value-accessor';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { OptionComponent } from '../option/option.component';
import { Option } from '../option/option.model';

@Component({
  selector: 'jhi-radio-box',
  templateUrl: './radio-box.component.html',
  styleUrls: ['./radio-box.component.scss'],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: RadioBoxComponent,
    multi: true
  }]
})

export class RadioBoxComponent extends BaseControlValueAccessor implements AfterContentInit {

  @ContentChildren(OptionComponent)
  components: QueryList<OptionComponent>;

  value: any;

  options: Array<Option>;

  constructor(injector: Injector) {
    super(injector);
  }

  ngAfterContentInit(): void {
    super.ngAfterContentInit();
    this.options = this.components.map(component => ({
      label: component.label,
      value: component.value,
      selected: this.isEquals(component.value, this.value),
      disabled: component.disabled
    }));
  }

  modelValueChanged(value: any): void {
    this.value = value;
    this.options.forEach(option => option.selected = this.isEquals(this.value, option.value));
  }

}



// WEBPACK FOOTER //
// ./src/main/webapp/app/shared/components/forms/radio-box/radio-box.component.ts